import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { QuoteButton } from "../home/CtaButtons";
import { CompareLink } from "../info/InfoHero";
import { trackEvent } from "../../lib/api";

export const CTA_TARGETS = [
  ["wizard", "Prijsindicatie aanvragen (offertewizard)"], ["vergelijken", "Offerte laten vergelijken"],
  ["isde", "ISDE-subsidiecheck"], ["contact", "Contact opnemen"],
];
const LINKS = { isde: ["/isde-subsidie-kozijnen#subsidiecheck", "Bereken uw ISDE-subsidie"], contact: ["/contact", "Neem contact op"] };

// Offerteblok in een artikel: altijd een duidelijke vervolgstap naar wizard, vergelijker, ISDE-check of contact.
export const ArticleCta = ({ b, i }) => {
  const loc = `kb-article-cta-${i}`;
  const link = LINKS[b.target];
  return (
    <aside className="relative my-10 overflow-hidden rounded-2xl bg-ink px-6 py-8 sm:px-8" data-testid={`kb-block-cta-${i}`}>
      <div className="hero-grid-dark absolute inset-0 opacity-50" aria-hidden="true" />
      <div className="relative">
        <p className="text-[20px] font-bold leading-snug text-white sm:text-[22px]">{b.title || "Benieuwd wat dit voor uw woning betekent?"}</p>
        {b.text && <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-slate-300">{b.text}</p>}
        <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
          {b.target === "wizard" && <QuoteButton location={loc} onderwerp={b.onderwerp || undefined} />}
          {b.target === "vergelijken" && <CompareLink location={loc} dark label="Laat uw offerte vrijblijvend vergelijken" />}
          {link && (
            <Link to={link[0]} onClick={() => trackEvent("cta_article_click", { location: loc, target: b.target })} className="btn-cta group" data-testid={`${loc}-link`}>
              {link[1]} <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
          )}
          {b.target === "wizard" && <CompareLink location={`${loc}-2`} dark />}
        </div>
      </div>
    </aside>
  );
};
